export default {
  "A confirmation code has just been sent to you by message": "Us hem enviat un codi de verificació per SMS",
  "Already have an account": "Ja teniu un compte",
  "Beyond this time, the reservation we retain will be available again for others": "Passat aquest temps, la reserva que mantenim tornarà a estar disponible per a altres persones",
  "Book now": "Reserva ara",
  "Booking": "Reserva",
  "Booking information": "Informació de la reserva",
  "Booking start the first day at {startTime} and finish the last day at {endTime}": "La reserva comença el primer dia a les {startTime} i acaba l’últim dia a les {endTime}",
  "Cancel booking": "Cancel·la la reserva",
  "Choose your date": "Trieu la data",
  "Confirm my phone number": "Confirma el meu número de telèfon",
  "Confirm my registration": "Confirma la meva inscripció",
  "Confirm my booking": "Confirma la meva reserva",
  "Confirm my registration and pay": "Confirma la meva inscripció i paga",
  "Continue as guest": "Continua com a convidat",
  "Continue to registration": "Continua cap a la inscripció",
  "Create an account": "Crea un compte",
  "Dates": "Dates",
  "End Date of Reservation": "Data de finalització de la reserva",
  "Enlarge map": "Amplia el mapa",
  "Enter your code here to confirm your registration": "Introduïu aquí el codi per confirmar la vostra inscripció",
  "I accept the Terms and conditions of registration": "Accepto els termes i condicions d’inscripció",
  "Loading…": "S’està carregant…",
  "Location": "Ubicació",
  "More information": "Més informació",
  "No slots available": "No hi ha franges disponibles",
  "Processing booking…": "S’està processant la reserva…",
  "Processing payment…": "S’està processant el pagament…",
  "Product": "Producte",
  "Recording payment…": "S’està registrant el pagament…",
  "Reduce map": "Redueix el mapa",
  "Remaining time": "Temps restant",
  "Required fields": "Camps obligatoris",
  "Reserving a product is mandatory for registration": "Reservar un producte és obligatori per a la inscripció",
  "Retrieving available slots": "S’estan recuperant les franges disponibles",
  "Saving registration…": "S’està desant la inscripció…",
  "Select size first": "Seleccioneu primer la talla",
  "Select stage first": "Seleccioneu primer la sessió",
  "Select your options and dates to book": "Seleccioneu les opcions i les dates per reservar",
  "Size": "Talla",
  "Slot": "Franja",
  "Stage": "Sessió",
  "Store": "Botiga",
  "Start Date of Reservation": "Data d’inici de la reserva",
  "View terms and conditions": "Veure els termes i condicions",
  "You do not want to create an account": "No voleu crear un compte",
  "The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.": "El producte seleccionat s’ha reservat per a vosaltres. Teniu {minutes} minuts per completar el procés introduint les vostres dades personals a la pàgina següent.",
  "Your reservation is in progress!": "La vostra reserva està en curs!",
  "not available": "no disponible",
  "remaining place": "plaça restant|places restants",
  "see availability": "veure la disponibilitat",
  "Email Address": "Adreça de correu electrònic",
  "Phone": "Telèfon",
  "Birthdate": "Data de naixement",
  "ProductTypes": "Tipus de producte",
  "Sizes": "Talles",
  "Filter": "Filtra",
  "Select a date": "Seleccioneu una data",
  "Give us your opinion": "Doneu-nos la vostra opinió",
  "Thank you for your review!": "Gràcies per la vostra ressenya!",
  "You can also review these products": "També podeu valorar aquests productes",
  "Undo": "Desfés",
  "Redo": "Refés",
  "Bold": "Negreta",
  "Italic": "Cursiva",
  "Strikethrough": "Ratllat",
  "Paragraph": "Paràgraf",
  "Add Link": "Afegeix un enllaç",
  "Remove Link": "Elimina l’enllaç",
  "Headings": "Encapçalaments",
  "Heading 2": "Encapçalament 2",
  "Heading 3": "Encapçalament 3",
  "Heading 4": "Encapçalament 4",
  "Heading 5": "Encapçalament 5",
  "Heading 6": "Encapçalament 6",
  "Bullet List": "Llista amb pics",
  "Numbered List": "Llista numerada",
  "Clear Formatting": "Esborra el format",
  "Overall Rating": "Valoració global",
  "Review title": "Títol de la ressenya",
  "Summarize your impression on the product": "Resumiu la vostra impressió sobre el producte",
  "Your detailed product review": "La vostra ressenya detallada del producte",
  "50 characters minimum": "50 caràcters com a mínim",
  "What was your impression of the product while testing? What did you like or dislike about the product? What conditions where present while testing the product?": "Quina impressió us va fer el producte durant la prova? Què us ha agradat o no del producte? Quines condicions hi havia durant la prova?",
  "50 characters (minimum)": "50 caràcters (mínim)",
  "Comments": "Comentaris",
  "Comments on the reception, the organization, the advice on the product…": "Comentaris sobre l’acollida, l’organització, els consells sobre el producte…",
  "Would you recommend this product to a friend?": "Recomanaríeu aquest producte a un amic?",
  "Would you be ready to buy this product?": "Estaríeu disposats a comprar aquest producte?",
  "First name or pseudo": "Nom o pseudònim",
  "Your name / nickname is published with your review": "El vostre nom o pseudònim es publica amb la ressenya",
  "I have read and I accept the terms and conditions": "He llegit i accepto els termes i condicions",
  "of publication of the reviews": "de publicació de les ressenyes",
  "and": "i",
  "the privacy policy": "la política de privacitat",
  "Post Review": "Publica la ressenya",
  "Very bad": "Molt dolent",
  "Bad": "Dolent",
  "Average": "Mitjà",
  "Good": "Bo",
  "Great!": "Excel·lent!",
  "Image caption": "Peu de foto",
  "No": "No",
  "Yes": "Sí",
  "Booking dates": "Dates de la reserva",
  "Registration": "Inscripció",
  "Status": "Estat",
  "Created at": "Creat el",
  "Actions": "Accions",
  "Cancel": "Cancel·la",
  "This site is protected by reCAPTCHA.": "Aquest lloc està protegit per reCAPTCHA.",
  "Google Privacy Policy": "Política de privacitat de Google",
  "Google Terms of Service": "Condicions del servei de Google",
  "Read the full text": "Llegiu el text complet",
};
